'use client';

import React from 'react';
import { ImageModal } from '@/components/ImageModal';
import { useTranslations } from '@/hooks/useTranslations';

type RichTextExpandableImageProps = {
  src: string;
  alt: string;
};

export function RichTextExpandableImage({ src, alt }: RichTextExpandableImageProps) {
  const { t } = useTranslations();
  const [open, setOpen] = React.useState(false);

  const label = alt || t('blog.expandImage');

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="group mx-auto my-6 block w-full max-w-full text-center sm:max-w-xl md:max-w-2xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ffb74d]/50"
        aria-label={t('blog.viewLargerImage', { label })}
      >
        <span className="relative block rounded-xl border border-white/10 bg-white/5 transition group-hover:border-[#ffb74d]/30">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={src}
            alt={alt}
            className="h-auto w-full rounded-xl object-contain"
            loading="lazy"
          />
          <span
            aria-hidden="true"
            className="absolute inset-0 flex items-center justify-center bg-black/0 transition group-hover:bg-black/20"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-black/55 text-white opacity-0 shadow-lg transition group-hover:opacity-100">
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                />
              </svg>
            </span>
          </span>
        </span>
        <span className="mt-1.5 block text-xs text-slate-500 transition group-hover:text-slate-400">
          {t('blog.clickToExpand')}
        </span>
      </button>

      {open ? (
        <ImageModal imageUrl={src} alt={label} title={label} onClose={() => setOpen(false)} />
      ) : null}
    </>
  );
}
